<script setup>
const props = defineProps({
  title: String,
  description: String,
  access: String,
  total: Number,
  count: Number,
  showHelpButton: Boolean,
  helpStatus: Boolean,
  tabs: Array,
  tag: String,
})
const emit = defineEmits(['help-button-click'])
const userStore = useUserStore()
const config = useRuntimeConfig()
const platform = 'web'
</script>

<template>
  <div class="text-poivre-700  print:hidden xl:pt-5 w-full max-w-7xl mx-auto px-0 xl:px-8">
    <div v-if="tabs" class="flex justify-between md:justify-start">
      <ULink v-for="tab in tabs" :key="tab.label" :to="tab.to" class="text-sm md:text-base w-full md:w-auto text-center justify-center py-2 font-medium lg:rounded-t-md items-center flex space-x-1 " :class="tab.active ? 'bg-white text-tomate px-2 xl:px-4' : 'bg-transparent text-poivre px-2 xl:px-4'">
        <span>{{ tab.label }}</span><UIcon v-if="tab.extra" name="i-mdi-star" class="text-tomate" />
      </ULink>
    </div>
    <div class="bg-white px-4 lg:px-6 py-4" :class="tabs && tabs[0] && tabs[0].active ? 'xl:rounded-tr-lg xl:rounded-br-lg xl:rounded-bl-lg' : 'xl:rounded-lg'">
      <button
        v-if="platform !== 'web'"
        class="flex items-center justify-center border-poivre-200 border-1 px-2 py-1 rounded mb-2 text-poivre-600 text-xs"
        @click="router.go(-1)"
      >
        <UIcon name="i-mdi-chevron-left" />
        <span>Retour</span>
      </button>

      <div>
        <div class="flex items-center justify-start space-x-1">
          <h2 class="xl:font-title uppercase xl:normal-case text-lg font-semibold xl:text-4xl text-poivre text-poivre">
            {{ props.title }}
          </h2>
          <UButton
            v-if="props.showHelpButton && !props.helpStatus"
            color="neutral"
            class="text-gray-400"
            variant="ghost"
            icon="i-mdi-help-circle-outline"
            @click="emit('help-button-click')"
          />
          <UButton
            v-else-if="props.helpStatus && props.showHelpButton"
            color="neutral"
            class="text-gray-400"
            variant="ghost"
            icon="i-mdi-close-circle"
            @click="emit('help-button-click')"
          />
        </div>
      </div>

      <div v-if="props.tag" class="mt-0 mb-1">
        <UBadge variant="soft" color="primary" :label="props.tag" />
      </div>

      <div class="text-poivre-700 mt-1 sm:mt-1 leading-5">
        {{ props.description }}
      </div>

      <div v-if="props.count && props.count > 0" class="inline-block bg-sorbet-200 rounded-md px-3 py-1.5 mt-2 text-sm text-poivre-700 font-medium">
        {{ props.count }} {{ props.count === 1 ? 'résultat' : 'résultats' }}
      </div>

      <div class="flex space-x-2 sm:space-x-4 hidden">
        <button
          v-if="props.showHelpButton"
          type="button"
          class="inline-flex justify-center px-2 sm:px-3 py-1 mt-2 text-sm font-medium text-poivre-600 bg-white border border-poivre-200 rounded-full shadow-sm hover:bg-poivre-50 focus:outline-none focus:ring-0"
          @click="emit('help-button-click')"
        >
          <UIcon
            v-if="!props.helpStatus"
            name="i-mdi-help-circle-outline"
            class="w-5 h-5 mr-2 -ml-1 text-poivre-400"
            aria-hidden="true"
          />
          <UIcon
            v-else
            name="i-mdi-close-circle"
            class="w-5 h-5 mr-2 -ml-1 text-poivre-400"
            aria-hidden="true"
          />
          <span v-if="!props.helpStatus">Comment ça fonctionne?</span>
          <span v-else>Fermer l'aide</span>
        </button>
      </div>

      <div
        v-if="props.access && (!userStore.user || userStore.user.extra == 0)"
        class="flex items-center mt-2 text-sm text-poivre-400 leading-4"
      >
        <UIcon name="i-mdi-key" class="size-4 inline mr-1 text-tomate" /> {{ props.access }}
      </div>
    </div>
  </div>
</template>
